import { decode } from 'jsonwebtoken';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

const useApplicationUid = () => {
  const JwtToken = retrieveFromSessionStorage('JwtToken');

  if (JwtToken) {
    const { ApplicationUid } = decode(JwtToken);

    return { ApplicationUid };
  }
  return null;
};

export default useApplicationUid;
